import {
    request,
} from '../request.js'

// 获取
export function reqdictList(data) {
    return request({
        url: '/web/back/sys/dict/list',
        method: 'post',
        data
    })
}

// 筛选数据  
export function reqSelect() {
    return request({
        url: '/web/back/sys/dict/selectByFirstType',
        method: 'get',
    })
}
// 添加
export function reqAdddict(data) {
    return request({
        url: '/web/back/sys/dict/insert',
        method: 'post',
        data
    })
}

// 删除
export function reqDeletedict(id) {
    return request({
        url: '/web/back/sys/dict/delete',
        method: 'delete',
        params: {
            id
        }
    })
}

// 更新 
export function reqUpdatedict(data) {
    return request({
        url: '/web/back/sys/dict/update',
        method: 'post',
        data
    })
}

//  reqMax
export function reqMax(data) {
    return request({
        url: '/web/back/sys/dict/selectByMaxValue',
        method: 'post',
        data
    })
}